/** The ticket route: loads `tickets.get` and hands it to `TicketView` (`components/ticket/ticket-view.tsx`). */
import { useQuery } from '@tanstack/react-query';
import { Link, createFileRoute } from '@tanstack/react-router';
import { Ticket } from '../../components/ticket/ticket-view';
import { useProvideAssistantContext } from '../../lib/assistant-context';
import { ticketQuery } from '../../lib/queries';
import { describeRpcError } from '../../lib/rpc';

export const Route = createFileRoute('/tickets/$ticketId')({
  loader: ({ context, params }) => context.queryClient.query({ ...ticketQuery(params.ticketId), staleTime: 'static' }),
  component: TicketPage,
  pendingComponent: () => <div className="px-6 pt-6 text-body text-ink-3">Opening ticket</div>,
  errorComponent: ({ error }) => <div className="px-6 pt-6 text-body text-alert">{describeRpcError(error)}</div>,
});

function TicketPage() {
  const { ticketId } = Route.useParams();
  const { data } = useQuery(ticketQuery(ticketId));
  useProvideAssistantContext(data ? [{ label: data.ticketNumber }, ...(data.account ? [{ label: data.account.label }] : [])] : null);

  if (data === null) {
    return (
      <div className="px-6 pt-6">
        <p className="text-body text-ink-2">That ticket is not here. It may have been merged or the link is stale.</p>
        <Link to="/board" className="mt-2 inline-block text-body text-info hover:underline">
          Back to the board
        </Link>
      </div>
    );
  }
  if (!data) return null;
  return <Ticket t={data} />;
}

